import React from 'react';
import { connect } from 'react-redux';
import { InfoBar } from 'ctia-ui';
import { lastWizardStep } from 'actions/wizard';
import { getDeviceTitle } from 'helpers/DeviceTypeHelper';

const SubmitInfoBar = ({ request, user, wizard }) => {
  const { step } = wizard;

  if (!(step > 1 && step < lastWizardStep)) return null;

  const reqDataInfo = [
    {
      key: 'Manufacturer',
      value: user.company
    },
    {
      key: 'Model Name/Number',
      value: request.modelName
    },
    {
      key: 'Device Type',
      value: getDeviceTitle(request.deviceType)
    }
  ];

  return <InfoBar show={true} data={reqDataInfo} />;
};

function mapStateToProps({ request, wizard, user }) {
  return { request, wizard, user };
}

export default connect(mapStateToProps)(SubmitInfoBar);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/SubmitInfoBar.js